import { useSelector } from 'react-redux';
import { selectCurrUserPermission } from '@/store/bootstrap/selectors';
import { useAuth } from '@/hooks';

const defaultConfigs = [
  {
    id: 'isCirclesEnabled',
    permission: 'intro.show?',
    featureFlag: 'circles_enabled',
  },
  {
    id: 'isFlowEnabled',
    permission: 'outreach.show?',
    featureFlag: 'outreach_enabled',
  },
  {
    id: 'isAccountInviteEnabled',
    permission: 'account_invitation.create?',
    featureFlag: 'outreach_enabled',
  },
  {
    id: 'isReportsEnabled',
    permission: 'reports_flow_health.create?',
    featureFlag: 'reports_basic_enabled',
  },
  // Add more default configurations here if needed
];

function checkPermissions(permissions = {}, spec) {
  if (typeof spec === 'string') {
    return permissions[spec];
  }
  const { any, all } = spec;
  return (
    (any ? any.some((perm) => permissions[perm]) : true) &&
    (all ? all.every((perm) => permissions[perm]) : true)
  );
}

export const usePermissionGuard = () => {
  const { currUser } = useAuth();
  const permissions = useSelector(selectCurrUserPermission);
  const permissionValues = {};

  defaultConfigs.forEach(({ id, permission, featureFlag }) => {
    const isFeatureEnabled =
      typeof featureFlag === 'string'
        ? currUser?.[featureFlag] || currUser?.feature_options?.[featureFlag]
        : true;
    const hasPermission = checkPermissions(permissions, permission);
    permissionValues[id] = hasPermission && isFeatureEnabled;
  });

  // Add default boolean value for non-existent permissions
  Object.keys(permissionValues).forEach((key) => {
    if (typeof permissionValues[key] !== 'boolean') {
      permissionValues[key] = false; // Change the default boolean value as needed
    }
  });

  return { ...permissionValues, permissions };
};
